// TODO: delete dummy data when we connect this to the backend
// app/widgets/engine.py WidgetEngine
// app/widgets/types.py shaper

export default {
    heatUS: {
        Alabama: 3.3,
        Alaska: 6.3,
        Arizona: 4.9,
        Arkansas: 3.4,
        California: 4.1,
        Colorado: 2.9,
        Connecticut: 3.6,
        Delaware: 3.3,
        "District of Columbia": 5.6,
        Florida: 3.3,
        Georgia: 3.6,
        Hawaii: 2.8,
        Idaho: 2.9,
        Illinois: 4.2,
        Indiana: 3.4,
        Iowa: 2.5,
        Kansas: 3.3,
        Kentucky: 4.3,
        Louisiana: 4.3,
        Maine: 3,
        Maryland: 3.8,
        Massachusetts: 2.9,
        Michigan: 4.3,
        Minnesota: 3.4,
        Mississippi: 5.1,
        Missouri: 3.3,
        Montana: 3.4,
        Nebraska: 3.1,
        Nevada: 4.1,
        "New Hampshire": 2.5,
        "New Jersey": 3.3,
        "New Mexico": 4.9,
        "New York": 4,
        "North Carolina": 4.2,
        "North Dakota": 2.4,
        Ohio: 4,
        Oklahoma: 3.2,
        Oregon: 4,
        Pennsylvania: 3.9,
        "Rhode Island": 3.5,
        "South Carolina": 3.4,
        "South Dakota": 2.9,
        Tennessee: 3.5,
        Texas: 3.4,
        Utah: 2.8,
        Vermont: 2.1,
        Virginia: 2.9,
        Washington: 4.6,
        "West Virginia": 4.7,
        Wisconsin: 3,
        Wyoming: 3.6,
    },
    heatWorld: {
        Afghanistan: 53,
        Albania: 68.1,
        Algeria: 65.5,
        Andorra: NaN,
        Angola: 55.8,
        "Antigua and Barb.": 67,
        Argentina: 68.4,
        Armenia: 66.3,
        Australia: 73,
        Austria: 72.4,
        Azerbaijan: 64.9,
        Bahamas: 66.8,
        Bahrain: 68.1,
        Bangladesh: 63.3,
        Barbados: 67,
        Belarus: 65.5,
        Belgium: 71.6,
        Belize: 62.5,
        Benin: 53.5,
        Bhutan: 60.7,
        Bolivia: 63,
        "Bosnia and Herz.": 67.2,
        Botswana: 57.5,
        Brazil: 66,
        Brunei: 67.9,
        Bulgaria: 66.4,
        "Burkina Faso": 52.9,
        Burundi: 52.6,
        "Cabo Verde": 64.5,
        Cambodia: 60.8,
        Cameroon: 51.1,
        Canada: 73.2,
        "Central African Rep.": 44.9,
        Chad: 47.2,
        Chile: 69.7,
        China: 68.7,
        Colombia: 67.1,
        Comoros: 56.6,
        Congo: 56.7,
        "Cook Is.": NaN,
        "Costa Rica": 70.9,
        "Côte d'Ivoire": 48.3,
        Croatia: 69,
        Cuba: 69.9,
        Cyprus: 73.3,
        Czechia: 69.3,
        "North Korea": 64.6,
        "Dem. Rep. Congo": 52.5,
        Denmark: 71.8,
        Djibouti: 56.6,
        Dominica: NaN,
        "Dominican Rep.": 65.2,
        Ecuador: 67.9,
        Egypt: 61.1,
        "El Salvador": 65.5,
        "Eq. Guinea": 53.8,
        Eritrea: 57.4,
        Estonia: 68.2,
        Ethiopia: 57.5,
        Fiji: 61.3,
        Finland: 71.7,
        France: 73.4,
        Gabon: 58.7,
        Gambia: 54.4,
        Georgia: 64.9,
        Germany: 71.6,
        Ghana: 56.4,
        Greece: 72,
        Grenada: 64.7,
        Guatemala: 64.2,
        Guinea: 52.2,
        "Guinea-Bissau": 51.7,
        Guyana: 58.3,
        Haiti: 55.3,
        Honduras: 66.8,
        Hungary: 66.8,
        Iceland: 73,
        India: 59.3,
        Indonesia: 61.7,
        Iran: 65.4,
        Iraq: 59,
        Ireland: 72.1,
        Israel: 72.9,
        Italy: 73.2,
        Jamaica: 66.9,
        Japan: 74.8,
        Jordan: 66.4,
        Kazakhstan: 63.4,
        Kenya: 58.9,
        Kiribati: 57.8,
        Kuwait: 66.3,
        Kyrgyzstan: 63.5,
        Laos: 57.9,
        Latvia: 66.2,
        Lebanon: 66.1,
        Lesotho: 46.6,
        Liberia: 54.5,
        Libya: 62.3,
        Lithuania: 66.1,
        Luxembourg: 72.6,
        Madagascar: 58.3,
        Malawi: 56.2,
        Malaysia: 66.6,
        Maldives: 69.8,
        Mali: 50.7,
        Malta: 72.2,
        "Marshall Is.": NaN,
        Mauritania: 56.4,
        Mauritius: 65.8,
        Mexico: 67.7,
        Micronesia: 61.1,
        Monaco: NaN,
        Mongolia: 61.9,
        Montenegro: 68.1,
        Morocco: 65.3,
        Mozambique: 52.2,
        Myanmar: 58.4,
        Namibia: 55.9,
        Nauru: NaN,
        Nepal: 61.3,
        Netherlands: 72.1,
        "New Zealand": 72.8,
        Nicaragua: 66.9,
        Niger: 52.5,
        Nigeria: 48.9,
        Niue: NaN,
        Norway: 73,
        Oman: 65.6,
        Pakistan: 57.7,
        Palau: NaN,
        Panama: 69.4,
        "Papua New Guinea": 58,
        Paraguay: 65.3,
        Peru: 67.5,
        Philippines: 61.7,
        Poland: 68.5,
        Portugal: 72,
        Qatar: 68.6,
        "South Korea": 73,
        Moldova: 63.6,
        Romania: 66.6,
        Russia: 63.5,
        Rwanda: 59.9,
        "St. Kitts and Nevis": NaN,
        "Saint Lucia": 66.4,
        "St. Vin. and Gren.": 63.4,
        Samoa: 66,
        "San Marino": NaN,
        "São Tomé and Principe": 60.7,
        "Saudi Arabia": 65.7,
        Senegal: 58.8,
        Serbia: 67.4,
        Seychelles: 65.7,
        "Sierra Leone": 47.6,
        Singapore: 76.2,
        Slovakia: 68.3,
        Slovenia: 70.5,
        "Solomon Is.": 61.9,
        Somalia: 50,
        "South Africa": 55.7,
        "S. Sudan": 50.6,
        Spain: 73.8,
        "Sri Lanka": 66.8,
        Sudan: 55.7,
        Suriname: 63.2,
        eSwatini: 50.2,
        Sweden: 72.4,
        Switzerland: 73.5,
        Syria: 55.8,
        Tajikistan: 63.5,
        Thailand: 66.8,
        Macedonia: 67.1,
        "Timor-Leste": 59.2,
        Togo: 53.9,
        Tonga: 64.3,
        "Trinidad and Tobago": 63.3,
        Tunisia: 66.3,
        Turkey: 66,
        Turkmenistan: 61.4,
        Tuvalu: NaN,
        Uganda: 54.9,
        Ukraine: 64,
        "United Arab Emirates": 66.7,
        "United Kingdom": 71.9,
        Tanzania: 56.5,
        "United States of America": 68.5,
        Uruguay: 68.8,
        Uzbekistan: 64.5,
        Vanuatu: 62.7,
        Venezuela: 66.1,
        Vietnam: 67.5,
        Yemen: 55.1,
        Zambia: 54.3,
        Zimbabwe: 54.4,
    },
    // https://en.wikipedia.org/wiki/List_of_largest_cities#List
    pointWorld: [
        {
            label: "Tokyo, Japan",
            lat: 35.6762,
            long: 139.6503,
        },
        {
            label: "Delhi, India",
            lat: 28.7041,
            long: 77.1025,
        },
        {
            label: "Shanghai, China",
            lat: 31.2304,
            long: 121.4737,
        },
        {
            label: "São Paulo, Brazil",
            lat: -23.5505,
            long: -46.6333,
        },
        {
            label: "Mexico City, Mexico",
            lat: 19.4326,
            long: -99.1332,
        },
        {
            label: "Cairo, Egypt",
            lat: 30.0444,
            long: 31.2357,
        },
        {
            label: "Mumbai, India",
            lat: 19.0760,
            long: 72.8777,
        },
        {
            label: "Beijing, China",
            lat: 39.9042,
            long: 116.4074,
        },
        {
            label: "Dhaka, Bangladesh",
            lat: 23.8103,
            long: 90.4125,
        },
        {
            label: "Osaka, Japan",
            lat: 34.6937,
            long: 135.5023,
        },
        {
            label: "New York City, United States",
            lat: 40.7128,
            long: -74.0060,
        },
        {
            label: "Karachi, Pakistan",
            lat: 24.8607,
            long: 67.0011,
        },
        {
            label: "Buenos Aires, Argentina",
            lat: -34.6037,
            long: -58.3816,
        },
        {
            label: "Chongqing, China",
            lat: 29.4316,
            long: 106.9123,
        },
        {
            label: "Istanbul, Turkey",
            lat: 41.0082,
            long: 28.9784,
        },
        {
            label: "Kolkata, India",
            lat: 22.5726,
            long: 88.3639,
        },
        {
            label: "Manila, Philippines",
            lat: 14.5995,
            long: 120.9842,
        },
        {
            label: "Lagos, Nigeria",
            lat: 6.5244,
            long: 3.3792,
        },
        {
            label: "Rio de Janeiro, Brazil",
            lat: -22.9068,
            long: -43.1729,
        },
        {
            label: "Tianjin, China",
            lat: 39.3434,
            long: 117.3616,
        },
    ],
    // https://www.w3.org/2003/01/geo/test/ustowns/latlong.htm
    // https://en.wikipedia.org/wiki/List_of_United_States_cities_by_population#50_states_and_District_of_Columbia
    pointUS: [
        {
            label: "New York, NY [NYC]",
            lat: 40.77,
            long: -73.98,
        },
        {
            label: "Los Angeles, CA [LAX]",
            lat: 33.93,
            long: -118.40,
        },
        {
            label: "Chicago, IL [CHI]",
            lat: 41.90,
            long: -87.65,
        },
        {
            label: "Houston, TX [IAH]",
            lat: 29.97,
            long: -95.35,
        },
        {
            label: "Phoenix, AZ [PHX]",
            lat: 33.43,
            long: -112.02,
        },
        {
            label: "Philadelphia, PA [PHL]",
            lat: 39.88,
            long: -75.25,
        },
        {
            label: "San Antonio, TX [SAT]",
            lat: 29.53,
            long: -98.47,
        },
        {
            label: "San Diego, CA [SAN]",
            lat: 32.73,
            long: -117.17,
        },
        {
            label: "Dallas/FW, TX [DFW]",
            lat: 32.90,
            long: -97.03,
        },
        {
            label: "San Jose, CA [SJC]",
            lat: 37.37,
            long: -121.92,
        },
        {
            label: "Austin, TX [AUS]",
            lat: 30.30,
            long: -97.70,
        },
        {
            label: "Jacksonville, FL [JAX]",
            lat: 30.50,
            long: -81.70,
        },
        {
            label: "Fort Worth, TX [FTW]",
            lat: 32.82,
            long: -97.35,
        },
        {
            label: "Columbus, OH [CMH]",
            lat: 40.00,
            long: -82.88,
        },
        {
            label: "Charlotte, NC [CLT]",
            lat: 35.22,
            long: -80.93,
        },
        {
            label: "San Francisco, CA [SFO]",
            lat: 37.62,
            long: -122.38,
        },
        {
            label: "Indianapolis, IN [IND]",
            lat: 39.73,
            long: -86.27,
        },
        {
            label: "Seattle, WA [SEA]",
            lat: 47.45,
            long: -122.30,
        },
        {
            label: "Denver, CO [DEN]",
            lat: 39.75,
            long: -104.87,
        },
        {
            label: "Washington/Natl, DC [DCA]",
            lat: 38.85,
            long: -77.04,
        },
    ],
    // https://en.wikipedia.org/wiki/List_of_cities_in_the_European_Union_by_population_within_city_limits
    pointEU: [
        {
            label: "Berlin, Germany",
            lat: 52.5200,
            long: 13.4050,
        },
        {
            label: "Madrid, Spain",
            lat: 40.4168,
            long: -3.7038,
        },
        {
            label: "Rome, Italy",
            lat: 41.9028,
            long: 12.4964,
        },
        {
            label: "Bucharest, Romania",
            lat: 44.4268,
            long: 26.1025,
        },
        {
            label: "Paris, France",
            lat: 48.8566,
            long: 2.3522,
        },
        {
            label: "Vienna, Austria",
            lat: 48.2082,
            long: 16.3738,
        },
        {
            label: "Hamburg, Germany",
            lat: 53.5511,
            long: 9.9937,
        },
        {
            label: "Warsaw, Poland",
            lat: 52.2297,
            long: 21.0122,
        },
        {
            label: "Budapest, Hungary",
            lat: 47.4979,
            long: 19.0402,
        },
        {
            label: "Barcelona, Spain",
            lat: 41.3851,
            long: 2.1734,
        },
        {
            label: "Munich, Germany",
            lat: 48.1351,
            long: 11.5820,
        },
        {
            label: "Milan, Italy",
            lat: 45.4642,
            long: 9.1900,
        },
        {
            label: "Prague, Czech Republic",
            lat: 50.0755,
            long: 14.4378,
        },
        {
            label: "Sofia, Bulgaria",
            lat: 42.6977,
            long: 23.3219,
        },
        {
            label: "Cologne, Germany",
            lat: 50.9375,
            long: 6.9603,
        },
        {
            label: "Stockholm, Sweden",
            lat: 59.3293,
            long: 18.0686,
        },
        {
            label: "Naples, Italy",
            lat: 40.8518,
            long: 14.2681,
        },
        {
            label: "Turin, Italy",
            lat: 45.0703,
            long: 7.6869,
        },
        {
            label: "Amsterdam, Netherlands",
            lat: 52.3676,
            long: 4.9041,
        },
        {
            label: "Marseille, France",
            lat: 43.2965,
            long: 5.3698,
        },
    ]
}
